module.exports = __webpack_public_path__ + "static/img/17023C_1_2_C_20210604_LC.04aed7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17023C_1_2_C_20210604_LC.png
// module id = vB9Y
// module chunks = 0